// The monthly run count resets at the start of the next UTC calendar month. The usage banner, the
// limits-reached modal and the runs-usage email all name this date to the user, so they read it from
// here rather than each formatting it themselves. Deliberately dependency-free: the frontend imports
// this module directly, and must not pull the rest of this package into its bundle.
export const getMonthlyRunsResetDate = (now: Date = new Date()): string => {
  const reset = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() + 1, 1));

  return reset.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC'
  });
};
